export default {
    getView: '/gateway/manageBedrock/free/questioncs/view', // 安全培训列表查询
}


// WEBPACK FOOTER //
// ./src/customerServiceCenter/detail/api.js